webpackJsonp([0],{

/***/ 2:
/***/ (function(module, exports) {

window.addEventListener('load', function () {
  console.log('Loaded custom JS');
});

/***/ })

},[2]);


// WEBPACK FOOTER //
// custom.bundle.js